import { combineReducers } from "redux";
import floatInput from "./FloatInput/reducer";

export default combineReducers({
  floatInput,
});
